module.exports = __webpack_public_path__ + "static/media/icon.e8ad4d49.png";